import React, { RefObject, useContext, useRef, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Navigation } from "swiper/modules"
import { IMediaCenterProps } from "./types"
import LatestNewsCard from "./LatestNewsCard"
import CircleIconButton from "../shared/CircleIconButton"
import OneDirectionArrow from "../shared/icons/OneDirectionArrow"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
const LatestNews = ({
	fullData,
	setModalData,
	sectionRef,
	label,
	insideAmenitiesDetailsPage,
	optimizedImage,
}: {
	fullData: IMediaCenterProps[]
	setModalData?: any
	sectionRef?: RefObject<HTMLDivElement | null>
	label?: string
	insideAmenitiesDetailsPage?: boolean
	optimizedImage?: boolean
}) => {
	const swiperRef = useRef<any>(null)
	const { isIpad, isMobile } = useContext(screenSizeContext)
	const [isBeginning, setIsBeginning] = useState(true)
	const [isEnd, setIsEnd] = useState(false)
	

	return (
		<div className="latesNews pt-[3rem] pb-[5rem] px-[1.125rem] md:px-8 bg-oBlue-100 ">
			<div className="header flex flex-row justify-between items-center w-[100%] mb-[2rem]  ">
				<div className=" text-h6 md:text-h4 font-minerva-regular text-oWhite-100 leading-[1] ">
					Latest {label}
				</div>
				<div className="navigation-container flex justify-end gap-4 z-[3] w-[calc(50%-1.5rem)]">
					<CircleIconButton
						style="white"
						icon={<OneDirectionArrow color="white" />}
						customClass="rotate-180 swiper-prev"
						disabled={isBeginning}
					/>
					<CircleIconButton
						style="white"
						icon={<OneDirectionArrow color="white" />}
						customClass="swiper-next"
						disabled={isEnd}
					/>
				</div>
			</div>
			<div className="latesNews_swiper">
				<Swiper
					ref={swiperRef}
					spaceBetween={20}
					slidesPerView={isIpad || isMobile ? 1.2 : 1.5}
					slidesPerGroup={1}
					navigation={{
						prevEl: ".swiper-prev",
						nextEl: ".swiper-next",
					}}
					modules={[Navigation]}
					onSlideChange={(swiper) => {
						setIsBeginning(swiper.isBeginning)
						setIsEnd(swiper.isEnd)
					}}
				>
					{fullData.map((item) => (
						<SwiperSlide key={item.id}>
							<LatestNewsCard
								data={item}
								setModalData={setModalData}
								sectionRef={sectionRef}
								insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
								optimizedImage={optimizedImage}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	)
}

export default LatestNews
